/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveLocationFromProjectCommand } from '../../models/remove-location-from-project-command';
import { RemoveLocationFromProjectCommandResult } from '../../models/remove-location-from-project-command-result';

export interface ApiProjectLocationsRemoveLocationFromProjectDelete$Params {
      body?: RemoveLocationFromProjectCommand
}

export function apiProjectLocationsRemoveLocationFromProjectDelete(http: HttpClient, rootUrl: string, params?: ApiProjectLocationsRemoveLocationFromProjectDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveLocationFromProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectLocationsRemoveLocationFromProjectDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RemoveLocationFromProjectCommandResult>;
    })
  );
}

apiProjectLocationsRemoveLocationFromProjectDelete.PATH = '/api/ProjectLocations/RemoveLocationFromProject';
